module.exports = __webpack_public_path__ + "img/logo@2x.d6b01d16.png";